var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",staticClass:"app page-404",attrs:{"id":"app"}},[_c('BlockError',{attrs:{"data":_vm.DataError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }